import { MKT } from 'src/sections/@dashboard/marketing/marketing.design';

// Metade deste arquivo (drawer/accounts/importSection/capability/
// permissionBanner/calendar/form/platformBadge/statusBadge) era herdada de um
// copy-paste de uma tela de contas sociais e nunca foi consumida por nenhum
// dos 4 tabs — removida. `charts`/`table`/`stats` continuam com forma propria
// porque os 4 tabs (Overview/Instagram/Facebook/GoogleAds) dependem
// extensivamente delas; so os valores foram atualizados pra tokens semanticos
// (bg-card/border-border/text-foreground) com suporte a dark.
export const MKT_ANALYTICS_DESIGN = {
    ...MKT,
    // stats.grid/gridWide/card/iconBox/value/label/growth vem de MKT — os
    // iconBox<Cor> antigos aqui eram consumidos so pelo MetricCard local
    // (removido; o componente compartilhado usa TONE_SOFT internamente).
    charts: {
        container: 'bg-card rounded-xl border border-border p-5 mb-4',
        title: 'text-sm font-semibold text-foreground mb-4',
        subtitle: 'text-xs text-muted-foreground mb-4',
        grid2: 'grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4',
        grid3: 'grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4',
    },
    // Estrutura identica ao original (so os valores de cor mudaram): container
    // sem padding, header/row cada um com seu proprio px-5 py-3 — alguns
    // consumidores usam `header` num <div> solto, outros (OverviewTab) num
    // <tr>, entao evitar qualquer classe de margin aqui pra nao depender de
    // como cada tab monta o layout ao redor.
    table: {
        container: 'bg-card rounded-xl border border-border overflow-hidden',
        header: 'px-5 py-3 border-b border-border flex items-center justify-between',
        headerTitle: 'text-sm font-semibold text-foreground',
        row: 'px-5 py-3 border-b border-border/60 flex items-center hover:bg-accent/50 transition-colors cursor-pointer',
        cell: 'text-sm text-foreground',
        cellMuted: 'text-xs text-muted-foreground',
    },
};
